import styled from 'styled-components'
import {mediumSmallFont} from '../../../../../theme/font-styles'
import {spacing} from '../../../../../theme/spacing'

export const ButtonText = styled.span`
    margin-left: ${spacing(1)};
    ${mediumSmallFont()};
    ${(props) => props.theme.font.weight.normal};
`
